module.exports = __webpack_public_path__ + "static/media/failed.e06f9cfc.svg";